import { gql } from '@apollo/client';
import { BlazeError } from '@blaze-cms/core-errors';
import upperFirst from 'lodash.upperfirst';
import { getQueryParams } from '../../../../utils';

function buildGetAllEntities(entitySchema, queryProps) {
  if (!entitySchema || !entitySchema.actions || !entitySchema.actions.getAll) {
    throw new BlazeError('DataEntity query requires getAll action from entity schema');
  }

  const sortParam = `${upperFirst(entitySchema.actions.getAll)}SortItem`;

  return gql`
    query getRelationsRecords($where: JSON, $sort: [${sortParam}]) {
      result: ${entitySchema.actions.getAll}(where: $where, sort: $sort) {
        ${queryProps || getQueryParams(entitySchema.displayProperties)}
      }
    }
  `;
}

export default buildGetAllEntities;
